export default __webpack_public_path__ + "static/media/Petals of Lilium.837349b9.jpg";